


























import { Mall } from 'ncp-api-supporter';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class MallDueDaysSummary extends Vue {
  @Prop({ required: true })
  private readonly selectMallNo!: '' | number;

  @State('malls', { namespace: 'mall' })
  private readonly malls!: Mall[];

  get selectedMallExpirationDueDays() {
    return this.malls.find(({ mallNo }) => this.selectMallNo === mallNo)?.expirationDueDays;
  }
}
